import { Box, Divider, Typography } from "@mui/material";
import React from "react";

import type { DashboardTaskRowModel } from "../../utils/crmOperationalDashboard.aggregate";
import { DashboardTaskRow } from "./DashboardTaskRow.component";

export type DashboardTaskPanelProps = {
  title: string;
  subtitle?: string;
  tasks: DashboardTaskRowModel[];
  loading?: boolean;
  urgentTone?: boolean;
  emptyLabel?: string;
};

export const DashboardTaskPanel = ({
  title,
  subtitle,
  tasks,
  loading,
  urgentTone,
  emptyLabel = "Nothing to show",
}: DashboardTaskPanelProps) => {
  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={600} color={urgentTone ? "error.main" : "text.primary"} gutterBottom>
        {title}
      </Typography>
      {subtitle ? (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
          {subtitle}
        </Typography>
      ) : null}
      {loading ? (
        <Typography variant="body2" color="text.secondary">
          Loading…
        </Typography>
      ) : !tasks?.length ? (
        <Typography variant="body2" color="text.secondary">
          {emptyLabel}
        </Typography>
      ) : (
        <Box sx={{ maxHeight: 360, overflowY: "auto", pr: 0.5 }}>
          {tasks.map((task, idx) => (
            <Box key={String(task.id)}>
              <DashboardTaskRow task={task} />
              {idx < tasks.length - 1 ? <Divider sx={{ my: 0.5 }} /> : null}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};
